(function (scope) {
	'use strict';

	var LityLightbox = function (elementsOrSelector) {
		this.litySelector = '.lity';
		
		if (typeof elementsOrSelector === 'string') {
			this.$elements = $(elementsOrSelector);
		} else if (elementsOrSelector !== undefined) {
			this.$elements = elementsOrSelector;
		}
		
		if (this.$elements.length) {
			this.initialize();
		} else {
			console.warn('LityLightbox selector doesn\'t match any elements.');
		}
	};

	LityLightbox.prototype.initialize = function () {
		this.addEventHandlers();
	};

	LityLightbox.prototype.addEventHandlers = function () {
		this.handleChangeCloseTitle = this.changeCloseTitle.bind(this);

		this.handleClick = this.onClick.bind(this);
		this.$elements.on('click touchdown', this.handleClick);
	};

	LityLightbox.prototype.onClick = function (event) {
		this.changeCloseTitle();
	};

	LityLightbox.prototype.changeCloseTitle = function () {
		var $lity = $(this.litySelector);
		if (!$lity.length) {
			window.setTimeout(this.handleChangeCloseTitle, 50);
		} else {
			var $lityClose = $lity.find('.lity-close');
			$lityClose.attr('title', __loco.lity_close);
		}
	};

	scope.LityLightbox = LityLightbox;
})(window.Roots || (window.Roots = {}));
